'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.iconWrapperStyles = undefined;

var _templateObject = _taggedTemplateLiteral(['\n\tg {\n\t\tfill: ', ';\n\t}\n\t&:disabled {\n\t\tg {\n\t\t\tfill: ', ';\n\t\t}\n\t}\n\t&:hover {\n\t\tg {\n\t\t\tfill: ', ';\n\t\t}\n\t}\n'], ['\n\tg {\n\t\tfill: ', ';\n\t}\n\t&:disabled {\n\t\tg {\n\t\t\tfill: ', ';\n\t\t}\n\t}\n\t&:hover {\n\t\tg {\n\t\t\tfill: ', ';\n\t\t}\n\t}\n']);

var _styledComponents = require('styled-components');

var _colors = require('../../constants/colors');

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var iconWrapperStyles = exports.iconWrapperStyles = (0, _styledComponents.css)(_templateObject, function (_ref) {
	var inverse = _ref.inverse,
	    disabled = _ref.disabled;
	return disabled ? _colors.Colors.cello15 : inverse ? _colors.Colors.LightMode : _colors.Colors.cello;
}, _colors.Colors.cello15, _colors.Colors.aqua);